import { Injectable } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';

@Injectable()
export class AppLocationStrategy extends PathLocationStrategy {
  prepareExternalUrl(internal: string): string {
    const url = super.prepareExternalUrl(internal);
    return this.stripTrailingDot(url);
  }

  private stripTrailingDot(url: string): string {
    const match = url.match(/#|\?|$/);
    const pathEndIdx = (match && match.index) || url.length;
    const droppedDotIdx = pathEndIdx - (url[pathEndIdx - 1] === '.' ? 1 : 0);
    return url.slice(0, droppedDotIdx) + url.slice(pathEndIdx);
  }
}
